<template>
  <div class="p-10 card pt-15 b-t-1-869fb229">
    <ValidationObserver ref="inventoryRef" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(confirmAction)">
        <div class="mx-5 card-body">
          <h3 class="text-center mb-3">Xác nhận điều chuyển thiết bị (Kho nhận)</h3>
          <p class="f14 text-center">
            <span class="f-700">Số phiếu:</span> {{ dataAdd.billNumber }}
          </p>
          <p class="f14 text-center">
            <span class="f-700">Ngày nhận:</span> {{ new Date().getTime() | formatDate }}
          </p>
          <div class="row mt-4">
            <div class="col-md-8">
              <p class="f14">
                <span class="f-700">Chuyển từ kho:</span>
                {{ dataAdd.inventoryNameExport }}
              </p>
              <p class="f14 my-1">
                <span class="f-700">Người duyệt điều chuyển:</span>
                {{ dataAdd.personApprove && dataAdd.personApprove.name }} -
                {{ dataAdd.personApprove && dataAdd.personApprove.email }}
              </p>
              <p class="f14 my-1">
                <span class="f-700">Lý do chuyển:</span>
                {{ dataAdd.reasonTransfer | transformData(Config.reasonTransferWarehouse) }}
              </p>
              <p class="f14"><span class="f-700">Ghi chú:</span> {{ dataAdd.description }}</p>
            </div>
            <div class="col-md-4">
              <p class="f14">
                <span class="f-700">Đến kho:</span>
                {{ dataAdd.inventoryNameImport }}
              </p>
            </div>
          </div>
          <div class="p-0 mt-4 card">
            <div
              class="mb-2 d-flex pos-relative w-100 justify-content-between align-items-baseline flex-wrap"
            >
              <h1 class="mb-1 form-inner-heading f-700">Danh sách thiết bị điều chuyển</h1>
            </div>
            <div class="tab-content">
              <div
                class="table-responsive b-table-sticky-header"
                style="overflow: auto; max-height: 70vh"
              >
                <table class="table table-hover table-bordered">
                  <thead class="thead-light">
                    <tr class="text-center">
                      <th>STT</th>
                      <th class="text-left">Tên loại thiết bị</th>
                      <th>Số lượng</th>
                      <th>Mã Serial</th>
                      <th>DVT</th>
                      <th>Tình trạng lúc xuất</th>
                      <th>Tình trạng lúc nhận</th>
                      <!-- <th class="text-center">
                        <div style="display: grid;grid-auto-flow: column;grid-auto-columns: max-content;gap: 4px;justify-content: center;">
                          Đã nhận<input type="checkbox" v-model="selectAll" />
                        </div>
                      </th> -->
                      <th>Ghi chú</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="table-row text-center"
                      v-for="(device, index) in dataAdd.devices"
                      :key="`device${index}`"
                    >
                      <td>{{ index + 1 }}</td>
                      <td class="text-left">{{ device.categoryName }}</td>
                      <td>{{ device.quantity ? device.quantity : '1' }}</td>
                      <td>{{ device.serial }}</td>
                      <td>{{ device.unit | transformData(Config.unitDevice) }}</td>
                      <td>
                        <span class="badge" :class="[device.type || '']">
                          {{ device.type | transformData(Config.stateDevices) }}
                        </span>
                      </td>
                      <td>
                        <span class="badge" :class="[device.type || '']">
                          {{ device.type | transformData(Config.stateDevices) }}
                        </span>
                      </td>
                      <!-- <td>
                        <input
                          type="checkbox"
                          v-model="device.isImport"
                          :value="device"
                        />
                      </td> -->
                      <td>
                        <ValidationProvider rules="minMaxName_4" :vid="device.id" name="Ghi chú">
                          <template slot-scope="{ errors }">
                            <input
                              v-model.trim="device.noteExport"
                              type="text"
                              class="form-control"
                              placeholder="Ghi chú"
                            />
                            <p class="text-danger">{{ errors[0] }}</p>
                          </template>
                        </ValidationProvider>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="box-header pb-1 pt-4">
              Tổng số thiết bị đã xuất:
              <strong class="text-primary">{{ dataAdd.quantityExport }}</strong>
              <div class="float-right">
                Tổng số thiết bị đã nhận:
                <strong class="text-primary">{{ dataAdd.quantityExport }}</strong>
              </div>
            </div>
            <div class="box-header py-1">
              Mã vận đơn:
              <strong class="text-primary">{{ dataAdd.shippingCode }}</strong>
            </div>
            <div class="box-header py-1">
              Đơn vị vận chuyển:
              <strong class="text-primary">{{ dataAdd.shippingUnit }}</strong>
            </div>
            <div class="box-header py-1">
              <ValidationProvider
                rules="minMaxName_4"
                vid="description"
                name="Ghi chú của Kho/ NV nhận"
              >
                <div class="form-group row my-0" slot-scope="{ errors }">
                  <label for class="col-sm-2 col-form-label">Ghi chú của Kho/ NV nhận:</label>
                  <div class="col-sm-4">
                    <input
                      v-model.trim="noteImport"
                      type="text"
                      class="form-control"
                      placeholder="Ghi chú của Kho/ NV nhận:"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
          <div class="float-right">
            <button type="submit" v-show="false"></button>
            <b-button
              class="mr-4"
              size="md"
              variant="light"
              @click="$router.push('/transfer-warehouse')"
            >
              Đóng
            </b-button>
            <b-overlay
              :show="loading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block"
            >
              <b-button
                :disabled="loading"
                @click="handleSubmit(confirmAction)"
                size="md"
                variant="primary"
              >
                Xác nhận
              </b-button>
            </b-overlay>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="text-center modal-body">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="py-3 f18">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="$router.push('/transfer-warehouse')"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import Config from '../../../thirdParty/config'

  export default {
    data() {
      return {
        Config,
        dataAdd: {
          dateTransfer: new Date().getTime(),
          reasonTransfer: 'TRANSFER_INTERNAL',
          devices: [],
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: 'cancel',
        reasonTransferData: Config.reasonTransferWarehouse,
        warehouseData: [],
        deviceCatData: [],
        noteImport: '',
      }
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },

    created() {
      this.fetchItem()
      this.fetchWarehouse()
      this.fetchCatDevice()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      selectAll: {
        get: function () {
          return !this.dataAdd.devices.find(s => s.isImport === false)
        },
        set: function (value) {
          if (value) {
            this.dataAdd.devices = this.dataAdd.devices.map(s => {
              s.isImport = true
              return s
            })
          } else {
            this.dataAdd.devices = this.dataAdd.devices.map(s => {
              s.isImport = false
              return s
            })
          }
        },
      },
    },

    methods: {
      confirmAction() {
        if (this.loading === true) return
        if (!this.dataAdd.devices.find(s => s.isImport === true)) {
          this.showErr('Bạn chưa tick chọn đã nhận thiết bị nào cả')
          return
        }
        const h = this.$createElement
        const messageVNode = h(
          'p',
          { class: 'f14' },
          `Bạn có chắc chắn nhận ${this.dataAdd.devices.filter(s => s.isImport === true).length} cho phiếu điều chuyển ${this.dataAdd.billNumber} không?`
        )
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Lưu ý',
            okTitle: 'Xác nhận',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(async value => {
            if (value) {
              this.loading = true
              const res = await DeviceService.approveImportTransferWarehouse({
                id: this.$route.params.entryId,
                noteImport: this.noteImport,
                devices: this.dataAdd.devices.map(({ id, isImport, kind, note, quantity }) => {
                  if (kind === 'NORMAL') {
                    return {
                      id,
                      importQuantity: quantity,
                      note,
                    }
                  } else return { id, isImport, note }
                }),
              })
              this.loading = false
              if (res.code === 1000) {
                this.keyCheck = 'accept'
                this.showSuccess(
                  `Xác nhận điều chuyển thiết bị cho phiếu ${this.dataAdd.billNumber} thành công`
                )
              } else {
                this.keyCheck = 'cancel'
                this.showErr(res.message)
              }
            }
          })
          .catch(() => {
            this.loading = false
          })
      },
      async fetchItem() {
        if (this.$route.params.entryId) {
          this.loading = true
          const res = await DeviceService.detailTransferWarehouse(this.$route.params.entryId)
          if (res.code === 1000) {
            this.dataAdd = {
              quantityExport: res.data.quantityExport,
              billNumber: res.data.billNumber,
              personApprove: res.data.personApprove,
              dateTransfer: res.data.timeExport,
              inventoryIdExport: res.data.inventoryIdExport,
              inventoryNameExport: res.data.inventoryNameExport,
              inventoryIdImport: res.data.inventoryIdImport,
              inventoryNameImport: res.data.inventoryNameImport,
              reasonTransfer: res.data.reasonTransfer,
              description: res.data.description,
              shippingCode: res.data.shippingCode,
              shippingUnit: res.data.shippingUnit,
              devices: res.data.devices.map(s => {
                return {
                  ...s,
                  isImport: true,
                }
              }),
            }
          }
          this.loading = false
        }
      },
      async fetchWarehouse() {
        const response = await DeviceService.getListSearchWarehouse()
        this.warehouseData = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
      },
      async fetchCatDevice() {
        const response = await DeviceService.listCatDevice({
          limit: 1000,
          page: 1,
        })
        this.deviceCatData = response.data.categoryList.map(({ name }) => {
          return { id: name, text: name }
        })
      },
      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },
      showSuccess(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-success2.svg')
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }
  .form-control-label {
    display: flex !important;
    align-items: center !important;
  }
</style>
